import React from 'react'
import PropTypes from 'prop-types'
import Form from 'react-bootstrap/Form'
import { useGetTruckTyreDimensionsQuery } from 'api/truckDimension'

import './style.css'

const TruckDimension = ({ selectedItem, onChange, disabled }) => {

	const { data: items, isLoading: loading } = useGetTruckTyreDimensionsQuery()

	return (
		<div className="truckDimension">
			<Form.Group>
				<Form.Control
					name="truckDimension"
					onChange={onChange}
					value={selectedItem}
					disabled={loading || disabled}
					as="select"
					size="lg"
				>
					<option value="">- Select dimension -</option>
					{items?.map((item) => (
						<option key={item.key} value={item.key}>
							{item.value}
						</option>
					))}
				</Form.Control>
			</Form.Group>
		</div>
	)
}

TruckDimension.propTypes = {
	selectedItem: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
}

export default TruckDimension
